import { useDispatch, useSelector } from 'react-redux'

import { useState } from 'react'
import { tasksActions } from '../../store/tasks'

import classes from './TasksHeaderCell.module.css'


export default function TasksHeaderCell({item}) {
    const dispatch = useDispatch()
    const [sortDirection, setSortDirection] = useState(true)

    const orderFilters = useSelector(state => state.tasks.orderFilters)
    const loading = useSelector(state => state.tasks.loading)

    async function sortTableHandler() {
        setSortDirection(prev => prev = !prev)
        dispatch(tasksActions.setOrderFilters({
            id: item.id,
            label: item.label,
            isDesc: sortDirection
        }))
    }

    return <div className={classes.header_cell} > 
        <div>
            {item.name} 
        </div>
        {item.sortable ? <button onClick={sortTableHandler} disabled={loading} className={`${classes.button} ${(orderFilters && orderFilters.id == item.group+item.label )? classes.active : ''}`}>
            {loading && <span className={`loader`}></span>}
            {!loading && <>
                {(orderFilters && orderFilters.id == item.group+item.label) ?  <>
                        {orderFilters.isDesc && <i className='ti ti-sort-descending'></i>}
                        {!orderFilters.isDesc && <i className='ti ti-sort-ascending'></i>}
                    </>
                    : <i className='ti ti-sort-descending'></i>}
            </>}
        </button> : ''}
    </div>
}